module.exports = __webpack_public_path__ + "static/img/eredin_commander.781f0dd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/monster/eredin_commander.png
// module id = pNd9
// module chunks = 0